export default "__VITE_ASSET__zctkOU97__"